import React from 'react'
import Alert from '~/Common-Objects/UI/Alert'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { Link } from 'react-router-dom'
import * as user from '../../data/actions/userActions' //now we can use user actions here

import { connect } from 'react-redux'
import { Translation } from 'react-i18next'
import queryString from 'query-string'
import i18nR from '~/i18n'
import ReCaptcha from '../../Common-Objects/Captcha'
import Template from './template'
import OneTimeCodeInput from '~/Common-Objects/OneTimeCodeInput'

//CONNECT TO STORE
@connect((store) => {
    return {
        user: store.user,
        siteMaster: store.siteMaster
    }
})
//NOW WE CAN USE FOR EXAMPLE {this.props.user.firstName} below - getting data from the store
export default class LoginTemplate extends React.Component {
    constructor(props, context) {
        super(props)
        this.state = {
            loaded: false,
            emailAddress: '',
            password: '',
            masterErrorMsg: '',
            masterErrorMsgTxt: '',
            twoFACode: '',
            redirect: '',
            AccountMasterId: '',
            captchaResponse: '',
            loggingIn: false,
            type: 'password',
            touched: false,
            invalid: false,
            useRecoveryCode: false
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputChange = this.inputChange.bind(this)
        this.redirectToPage = this.redirectToPage.bind(this)
        this.handleShowRecoveryCode = this.handleShowRecoveryCode.bind(this)
    }

    componentDidMount() {
        const query = queryString.parse(location.search)
        const token = query.usertoken

        if (token) {
            this.props.dispatch(user.loginAndGetToken(null, null, token, null))
        } else {
            this.setState({
                loaded: true,
                AccountMasterId: query.AccountMasterId ? parseInt(query.AccountMasterId) || '' : '',
                redirect: query.redirect,
                invalid: query.invalid
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.user.loginErrors != this.props.user.loginErrors) {
            if (this.props.user.loginErrors === 'soft2fa required') {
                this.props.history.push('/soft2fa')
            }
        }
        if (this.props.user.loginErrors && this.props.user.loginErrors != '') {
            var masterErrorMsg = (masterErrorMsg = i18nR.t('login:login.authenticationFailedRaw'))
            if (prevState.loggingIn) {
                this.setState({ loggingIn: false })
            }
            if (masterErrorMsg != prevState.masterErrorMsgTxt) {
                this.setState({
                    masterErrorMsgTxt: masterErrorMsg,
                    masterErrorMsg: <FormError data-test='login-error'>{masterErrorMsg}</FormError>
                })
            }
        } else {
            if (prevState.masterErrorMsgTxt != '') {
                this.setState({ masterErrorMsg: '', masterErrorMsgTxt: '', loggingIn: false })
            }
        }
    }

    redirectToPage(pageURL) {
        if (this.state.redirect) {
            pageURL += (pageURL.indexOf('?') > -1 ? '&' : '?') + 'redirect=' + this.state.redirect
        }
        this.props.history.push('/' + pageURL)
    }

    handleSubmit(event) {
        //Check the login in the store, and in the despatcher, if the login is valid save to store, and forward t oCP
        let token = this.state.captchaResponse
        this.setState({ captchaResponse: '', loggingIn: true, touched: true, masterErrorMsgTxt: '' })
        this.props.dispatch(
            user.loginAndGetToken(
                this.state.emailAddress,
                this.state.password,
                undefined,
                this.state.twoFACode,
                this.state.AccountMasterId,
                token
            )
        )
        if (event && event.preventDefault) event.preventDefault()
    }

    inputChange(event) {
        if (event.key === 'Enter') {
            this.handleSubmit()
        } else {
            this.setState({
                [event.currentTarget.name]: event.currentTarget.value
            })
        }
    }

    handleShowRecoveryCode(e) {
        e.preventDefault()
        this.setState({ useRecoveryCode: true })
    }

    render() {
        if (!this.state.loaded) return <div></div>

        var disableRegistration = false
        if (this.props.siteMaster && this.props.siteMaster.disableRegistration) disableRegistration = true

        let show2Fa = false
        let captchaRequired = false
        let errorMessage = this.state.masterErrorMsg
        let errorMessage2Fa = ''
        if (this.props.user.loginErrors && this.state.touched) {
            if (this.props.user.loginErrors.indexOf('twoFACode Required') > -1) {
                errorMessage = ''
                show2Fa = true
            }
            if (this.props.user.loginErrors.indexOf('twoFACode Failed') > -1) {
                errorMessage = ''
                errorMessage2Fa = 'Incorrect 2FA Code'
                show2Fa = true
            }
            if (this.props.user.loginErrors.indexOf('captcha') > -1) {
                errorMessage = ''
                captchaRequired = true
            }
        }

        const abovePaper = this.state.invalid ? (
            <Alert
                type='warning'
                className='landing-login__alert'
                header="We couldn't verify your login"
                content='This could be because the verification link expired. Please login and request verification again.'
            />
        ) : undefined

        return (
            <Translation ns='translations'>
                {(t, { i18n }) => {
                    let header = t('login:login.welcome')
                    let subheader = t('login:login.welcomeSub', { siteName: this.props.siteMaster.siteName })
                    if (show2Fa) {
                        header = t('login:login.2fa')
                        if (!this.state.useRecoveryCode) {
                            subheader = t('login:login.2faSub')
                        } else {
                            subheader = t('login:login.recoveryCodeSub')
                        }
                    }
                    return (
                        <Template
                            header={header}
                            subheader={subheader}
                            paperClasses='landing-login'
                            abovePaper={abovePaper}
                        >
                            {!show2Fa && (
                                <>
                                    <TextInput
                                        outerClassName='mar-b24'
                                        type='email'
                                        name='emailAddress'
                                        label={t('login:login.email')}
                                        value={this.state.emailAddress}
                                        onChange={this.inputChange}
                                        onEnterPress={this.handleSubmit}
                                        tabindex='1'
                                        autoFocus
                                    />
                                    <TextInput
                                        maxLength='255'
                                        outerClassName='mar-b32'
                                        type={this.state.type}
                                        label={t('login:login.password')}
                                        name='password'
                                        value={this.state.password}
                                        onChange={this.inputChange}
                                        onEnterPress={this.handleSubmit}
                                        tabindex='2'
                                        labelOptions={
                                            !this.props.siteMaster.hideForgottenPassword && (
                                                <Link to='/reminder'>{t('login:login.forgot')}</Link>
                                            )
                                        }
                                        iconRight={
                                            <Icons
                                                icon='eye'
                                                className={
                                                    this.state.type === 'password'
                                                        ? 'icons-cross'
                                                        : 'icons-cross active'
                                                }
                                                color='var(--neutral-900)'
                                                onClick={() => {
                                                    this.setState({
                                                        type: this.state.type === 'password' ? 'text' : 'password'
                                                    })
                                                }}
                                            />
                                        }
                                    />

                                    {!!errorMessage && this.state.touched && (
                                        <Alert
                                            type='error'
                                            header={t('login:login.bad')}
                                            content={t('login:login.badSub')}
                                            className='mar-b32'
                                        />
                                    )}

                                    <Button
                                        className='button-primary button-fullwidth'
                                        iconRight={<Icons icon='arrowRight' />}
                                        onClick={this.handleSubmit}
                                        disabled={this.state.loggingIn}
                                    >
                                        {t('login:login.login')}
                                    </Button>

                                    {!disableRegistration && (
                                        <div
                                            style={{
                                                fontWeight: 400,
                                                fontSize: 14,
                                                marginTop: 16,
                                                lineHeight: '22px',
                                                letterSpacing: '-0.13px',
                                                textAlign: 'center',
                                                color: 'var(--neutral-800)'
                                            }}
                                        >
                                            {t('login:login.register')}
                                            <Link to='/register' style={{ marginLeft: 5 }}>
                                                {t('login:login.getStarted')}
                                            </Link>
                                        </div>
                                    )}
                                </>
                            )}

                            {show2Fa && (
                                <>
                                    <OneTimeCodeInput
                                        code={this.state.twoFACode}
                                        isRecoveryCode={this.state.useRecoveryCode}
                                        onChange={(c) => this.setState({ twoFACode: c })}
                                        onEnter={(v) => {
                                            if (!v) return this.handleSubmit()
                                            this.setState(
                                                {
                                                    twoFACode: v
                                                },
                                                () => {
                                                    this.handleSubmit()
                                                }
                                            )
                                        }}
                                    />

                                    {!!errorMessage2Fa && (
                                        <Alert
                                            type='error'
                                            header={t('login:login.2faInvalid')}
                                            content={t('login:login.2faInvalidSub')}
                                            className='mar-b32'
                                        />
                                    )}

                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '16px',
                                            marginBottom: '16px'
                                        }}
                                    >
                                        <Button
                                            className='button-primary button-fullwidth'
                                            iconRight={<Icons icon='arrowRight' />}
                                            onClick={this.handleSubmit}
                                            disabled={this.state.loggingIn}
                                            onKeyPress={this.inputChange}
                                        >
                                            {t('login:login.verify')}
                                        </Button>
                                        {!this.state.useRecoveryCode && (
                                            <a onClick={this.handleShowRecoveryCode} disabled={this.state.loggingIn}>
                                                {t('login:login.useRecoveryCode')}
                                            </a>
                                        )}
                                    </div>
                                </>
                            )}

                            {captchaRequired && !this.state.captchaResponse && (
                                <ReCaptcha onComplete={(r) => this.setState({ captchaResponse: r })} />
                            )}
                        </Template>
                    )
                }}
            </Translation>
        )
    }
}
